module.exports = __webpack_public_path__ + "static/media/nav-icon-feedback-inactive.6a6bcdfa.svg";